import { FC } from "react";
import { useAuth } from "./AuthProvider";
import { LoginPage } from "../../pages/Login";

export const LoginSwitch: FC = ({ children }) => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <>{children}</> : <LoginPage />;
};
